/** 规范化用户会话名称；按 Unicode 字符限制长度，拒绝空白、控制字符和非文本输入。 */
export function normalizeSessionTitle(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const title = value.trim();
  return title && Array.from(title).length <= 256 && !/\p{Cc}/u.test(title) ? title : null;
}
